import { ExternalLink } from "../Link";

export function InstaAccountLink({
  account,
}: {
  account: { username: string };
}) {
  return (
    <ExternalLink href={`https://www.instagram.com/${account.username}`}>
      @{account.username}
    </ExternalLink>
  );
}
